<template>
  <div>
    <table-view
      ref="tableList"
      :tableModel="tableModel"
      :tableData="tableData"
      :searchModel="searchModel"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      @clickClearBtn="handleClickClearBtn"
      tableCardTitle="LENOVO REPORTS LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:vagueSearch>
        <div          style="display: flex; gap: 20px; align-items: center; width: calc(400% - 60px); margin-left: -100%; margin-bottom: 16px"
        >
          <div style="flex: 1; min-width: 260px">
            <el-form-item
              label="Customer ID / Customer Name"
              style="margin-bottom: 0"
            >
              <el-select
                v-model="vagueValue"
                placeholder="Customer ID / Customer Name"
                clearable
                filterable
                remote
                :remote-method="handleRemoteSearch"
                :loading="customerLoading"
                @clear="handleClearCustomer"
                @change="handleCustomerSelect"
                style="width: 100%"
              >
                <el-option
                  v-for="customer in customerList"
                  :key="customer.id"
                  :label="customer.displayName"
                  :value="customer.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <div style="flex: 1; min-width: 200px">
            <el-form-item label="Status" style="margin-bottom: 0">
              <el-select
                v-model="reportStatus"
                placeholder="Select Status"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="status in reportStatusList"
                  :key="status.id"
                  :label="status.name"
                  :value="status.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <div style="flex: 1; min-width: 200px">
            <el-form-item label="Submitted By" style="margin-bottom: 0">
              <el-select
                v-model="submittedBy"          style="width: 100%"
                filterable
                remote
                placeholder="Select Submitted By"
                :loading="submittedByLoading"
                :remote-method="querySubmittedBy"
                clearable
              >
                <el-option
                  v-for="name in submittedByOptions"
                  :key="name.id"
                  :label="name.username"
                  :value="name.username"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </template>
      <template v-slot:customerId="{ tableRow }">
        <span
          style="color: #409eff; cursor: pointer; text-decoration: underline"
          @click="handleCustomerIdClick(tableRow)"
        >
          {{ tableRow.row.code }}
        </span>
      </template>
      <template v-slot:reportType="{ tableRow }">
        <span>
          {{
            tableRow.row.reportType === 1
              ? 'Annual Report'
              : tableRow.row.reportType === 2
              ? 'Interim Report'
              : ' '
          }}
        </span>
      </template>
      <template v-slot:reportTime="{ tableRow }">
        <span>
          {{
            tableRow.row.reportQuarter
              ? `${tableRow.row.reportTime} - ${getQuarterName(
                  tableRow.row.reportQuarter,
                )}`
              : tableRow.row.reportTime
          }}
        </span>
      </template>
      <template v-slot:reportStatus="{ tableRow }">
        <span>
          {{ getReportStatusText(tableRow.row.reportStatus) }}
        </span>
      </template>
      <template v-slot:reportName="{ tableRow }">
        <span
          style="color: #409eff; cursor: pointer; text-decoration: underline"
          @click="handleDownloadOriginalFile(tableRow)"
        >
          {{ tableRow.row.reportName }}
        </span>
      </template>
      <template v-slot:action="{ tableRow }">
        <div style="white-space: nowrap">
          <el-button
            v-if="tableRow.row.reportStatus === 1"
            type="primary"
            size="mini"
            round
            style="background: #1890ff; border: none; margin-right: 8px"
            :loading="tableRow.row.downloadLoading"
            @click="handleDownloadFile(tableRow)"
          >
            Download
          </el-button>
          <el-button
            v-if="tableRow.row.reportStatus === 1"
            size="mini"
            round
            style="
              background: linear-gradient(90deg, #ff9100 0%, #f44336 100%);
              color: #fff;
              border: none;
            "
            @click="handleSaveToFinancialReport(tableRow)"
          >
            Save to Financial Report
          </el-button>
        </div>
      </template>
    </table-view>
    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="462px"
      @close="handleCancel"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form :model="form" ref="form" label-position="top">
          <el-form-item label="Currency" prop="currency">
            <el-select v-model="form.currency" style="width: 100%" filterable>
              <el-option
                v-for="item in this.currencyList"
                :label="item.currencyName"
                :value="item.currency"
                :key="item.currency"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="Exchange Date"
            v-if="form.currency !== 'USD'"
            prop="exchangeDate"
          >
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="form.exchangeDate"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="Exchange Rate(USD)"
            v-if="form.currency !== 'USD'"
            prop="exchangeRate"
          >
            <el-input :disabled="true" v-model="form.exchangeRate"></el-input>
          </el-form-item>
          <el-form-item label="Customer ID / Customer Name" prop="customerId">
            <el-select
              v-model="form.customerId"
              placeholder="Customer ID / Customer Name"
              clearable
              filterable
              remote
              :remote-method="handleAddFormRemoteSearch"
              :loading="addFormCustomerLoading"
              @clear="handleAddFormClearCustomer"
              style="width: 100%"
            >
              <el-option
                v-for="customer in addFormCustomerList"
                :key="customer.id"
                :label="customer.displayName"
                :value="customer.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="Financial Report Type" prop="reportType">
            <el-select
              v-model="form.reportType"
              style="width: 100%"
              placeholder="Select Financial Report Type"
            >
              <el-option
                v-for="item in addFormReportTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="Financial Report Time" prop="reportTime">
            <div style="display: flex; gap: 10px">
              <el-date-picker
                v-model="form.reportTime"
                type="year"
                placeholder="Select date"
                value-format="yyyy"
                style="flex: 1"
              />
              <el-select
                v-if="form.reportType === '2'"
                v-model="form.reportQuarter"
                placeholder="Select Quarter"
                style="flex: 1"
              >
                <el-option
                  v-for="item in this.QList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
          </el-form-item>

          <el-form-item>
            <el-upload
              ref="upload"
              :file-list="fileList"
              :before-upload="beforeUpload"
              :on-error="handleUploadError"
              :on-remove="handleRemove"
              :http-request="customUpload"
              action="#"
              accept=".pdf,.xls,.xlsx,.doc,.docx"
              :limit="1"
              :show-file-list="true"
              :auto-upload="true"
            >
              <el-button size="small" type="text" style="color: #409eff">
                Upload Documents
              </el-button>
            </el-upload>
          </el-form-item>

          <el-form-item style="margin-top: 20px">
            <el-checkbox v-model="form.saveToNotes">Save to Notes</el-checkbox>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">Cancel</el-button>
        <el-button
          type="primary"
          @click="handleSave"
          :loading="saveLoading"
          style="
            background: linear-gradient(90deg, #ff9100 0%, #f44336 100%);
            border: none;
          "
        >
          Submit
        </el-button>
      </span>
    </el-dialog>

    <!-- Save to Financial Report 弹窗 -->
    <el-dialog
      :visible.sync="saveToReportVisible"
      title="Save to Financial Report"
      width="500px"
      @close="handleSaveToReportCancel"
      :close-on-click-modal="false"
    >
      <el-form
        :model="saveToReportForm"
        ref="saveToReportForm"
        label-position="top"
      >
        <el-form-item label="Period Ending" prop="periodEnding">
          <el-date-picker
            v-model="saveToReportForm.periodEnding"
            type="date"
            placeholder="Select date"
            style="width: 100%"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>

        <el-form-item label="Account Type" prop="accountType">
          <el-select
            v-model="saveToReportForm.accountType"
            placeholder="Select Account Type"
            style="width: 100%"
          >
            <el-option
              v-for="item in accountTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Auditors'opinion" prop="auditorsOpinion">
          <el-select
            v-model="saveToReportForm.auditorsOpinion"
            placeholder="Select Auditors'opinion"
            style="width: 100%"
          >
            <el-option
              v-for="item in auditorsOpinionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleSaveToReportCancel">Cancel</el-button>
        <el-button
          type="primary"
          @click="handleSaveToReportSubmit"
          :loading="saveToReportLoading"
          style="
            background: linear-gradient(90deg, #ff9100 0%, #f44336 100%);
            border: none;
          "
        >
          Submit
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getReportList,
  getCustomerData,
  downloadFile,
  saveToFinancialReport,
  aiUploadFile,
  save,
  getCurrencyList,
  getCurrenyRate,
  duplicateFinancialReport,
  getCustomerByName,
  getSubmittedByList,
} from './api'

export default {
  data() {
    this.QList = [
      {
        id: 5,
        name: 'H1',
      },
      {
        id: 6,
        name: 'H2',
      },
      {
        id: 1,
        name: 'Q1',
      },
      {
        id: 2,
        name: 'Q2',
      },
      {
        id: 3,
        name: 'Q3',
      },
      {
        id: 4,
        name: 'Q4',
      },
    ]
    this.currencyList = []
    return {
      visible: false,
      saveLoading: false,
      saveToReportVisible: false,
      saveToReportLoading: false,
      saveToReportForm: {
        periodEnding: '',
        accountType: '',
        auditorsOpinion: '',
      },
      accountTypeOptions: [
        { value: '1', label: 'Consolidated' },
        { value: '2', label: 'Stand alone' },
      ],
      auditorsOpinionOptions: [
        { value: '1', label: 'Unqualified' },
        { value: '2', label: 'With Remarks' },
        { value: '3', label: 'Qualified' },
        { value: '4', label: 'Non-audited' },
      ],
      currentRowData: null, // 存储当前操作的行数据
      searchModel: [
        {
          label: '',
          type: 'input',
          key: '_placeholder',
          style: { display: 'none' },
        },
      ],
      reportStatusList: [
        { id: 1, name: 'Success' },
        { id: 2, name: 'Failure' },
        { id: 3, name: 'In Progress' },
      ],
      reportStatus: '',
      vagueValue: '', // 用于存储客户选择的值
      submittedBy: '',
      submittedByLoading: false, // 新增：Submitted By 加载状态
      submittedByOptions: [], // 新增：Submitted By 选项列表
      tableData: [],
      pages: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      form: {
        customerId: '',
        reportType: '',
        reportTime: '',
        reportQuarter: '',
        attachments: [],
        saveToNotes: false,
        currency: '',
        exchangeDate: '',
        exchangeRate: '',
      },
      fileList: [],
      addFormReportTypeList: [
        { value: '1', label: 'Annual Report' },
        { value: '2', label: 'Interim Report' },
      ],
      addFormCustomerList: [],
      addFormCustomerLoading: false,
      customerList: [],
      customerLoading: false,
    }
  },
  computed: {
    tableModel() {
      return [
        {
          label: 'Customer ID',
          prop: 'code',
          slotName: 'customerId',
          width: '200px',
        },
        {
          label: 'Customer Name',
          prop: 'name',
          width: '200px',
        },
        {
          label: 'Financial Report Type',
          prop: 'reportType',
          slotName: 'reportType',
          width: '200px',
        },
        {
          label: 'Financial Report Time',
          prop: 'reportTime',
          slotName: 'reportTime',
          width: '200px',
        },
        {
          label: 'Original Financial Report',
          prop: 'reportName',
          slotName: 'reportName',
          width: '200px',
        },
        {
          label: 'Submitted By',
          prop: 'submittedBy',
          width: '200px',
        },
        {
          label: 'Currency',
          prop: 'currency',
          width: '200px',
        },
        {
          label: 'Create Time',
          prop: 'createTime',
          width: '200px',
        },
        {
          label: 'Status',
          prop: 'reportStatus',
          slotName: 'reportStatus',
          width: '200px',
        },
        {
          label: 'Action',
          slotName: 'action',
          width: '280px',
        },
      ]
    },
    getReportStatusText() {
      return status => {
        switch (status) {
          case 1:
            return 'Success'
          case 2:
            return 'Failure'
          case 3:
            return 'In Progress'
          default:
            return ' '
        }
      }
    },
    getQuarterName() {
      return quarterId => {
        const quarter = this.QList.find(q => q.id === quarterId)
        return quarter ? quarter.name : ''
      }
    },
  },
  created() {
    this._getTableData()
  },
  methods: {
    customerType(val) {
      if (val === 1) {
        return 'Trade'
      } else if (val === 2) {
        return 'Eaas'
      } else if (val === 3) {
        return 'Saas'
      }
    },
    async _getCurrenyRate() {
      const { rate } = await getCurrenyRate(
        this.form.exchangeDate,
        this.form.currency,
      )
      console.log(rate)

      this.form.exchangeRate = rate
      console.log(this.form.exchangeRate)
    },
    async _getCurrencyList() {
      try {
        this.currencyList = await getCurrencyList()
      } catch (err) {
        console.error(err)
      }
    },
    async querySubmittedBy(query) {
      try {
        this.submittedByOptions = await this._getSubmittedByList(query)
      } catch (err) {
        console.error(err)
        this.submittedByOptions = []
      }
    },
    async _getSubmittedByList(query) {
      try {
        const response = await getSubmittedByList(query)
        // console.log(response)
        return response || []
      } catch (error) {
        console.error('获取 Submitted By 列表失败:', error)
        return []
      }
    },
    async _getTableData(params = {}) {
      // 如果有选中的客户，添加客户信息到查询参数
      if (this.vagueValue) {
        const selectedCustomer = this.customerList.find(
          customer => customer.id === this.vagueValue,
        )
        if (selectedCustomer) {
          params.companyId = selectedCustomer.id
          params.code = selectedCustomer.code
          params.name = selectedCustomer.name
        }
      }

      // 只添加必要的分页参数
      params.current = params.current || this.pages.current
      params.pageSize = this.pages.pageSize

      try {
        const { data, page } = await getReportList(params)
        this.tableData = data || []
        this.pages.total = page.total || 0
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(page) {
      // 处理page参数，可能是数字或对象
      const currentPage =
        typeof page === 'object'
          ? page.current || page.currentPage || page.page
          : page

      this.pages.current = currentPage
      const params = {}
      if (this.vagueValue) {
        const selectedCustomer = this.customerList.find(
          customer => customer.id === this.vagueValue,
        )
        if (selectedCustomer) {
          params.companyId = selectedCustomer.id
          params.code = selectedCustomer.code
          params.name = selectedCustomer.name
        }
      }

      if (this.reportStatus) {
        params.reportStatus = this.reportStatus
      }
      if (this.submittedBy) {
        params.submittedBy = this.submittedBy
      }
      // 从 table-view 组件获取其他搜索参数（如果组件支持）
      const additionalParams = this.$refs.tableList.getSearchData()
      Object.assign(params, additionalParams)

      delete params.size
      params.current = currentPage
      this._getTableData(params)
    },
    async handleTitleActionBtn() {
      this.form = {
        customerId: '',
        reportType: '',
        reportTime: '',
        reportQuarter: '',
        attachments: [],
        saveToNotes: true,
        currency: '',
        exchangeDate: '',
        exchangeRate: '',
      }
      this.fileList = []
      this.addFormCustomerList = []
      await this._getCurrencyList()
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    async handleSave() {
      if (!this.form.customerId) {
        this.$message.error('Please select customer')
        return
      }
      if (!this.form.reportType) {
        this.$message.error('Please select financial report type')
        return
      }
      if (!this.form.reportTime) {
        this.$message.error('Please select financial report time')
        return
      }
      if (!this.form.attachments || this.form.attachments.length === 0) {
        this.$message.error('Please upload file')
        return
      }

      this.saveLoading = true
      try {
        await save({
          companyId: this.form.customerId,
          reportType: this.form.reportType,
          reportTime: this.form.reportTime,
          notesFlag: this.form.saveToNotes ? 1 : 2,
          fileName: this.form.attachments[0].fileName,
          fileUrl: this.form.attachments[0].url,
          reportQuarter: this.form.reportQuarter,
          currency: this.form.currency,
          exchangeDate: this.form.exchangeDate,
          exchangeRate: this.form.exchangeRate,
        })
        this.$message.success('Add Successfully')
        this.visible = false
        this._getTableData()
      } catch (err) {
        console.error(err)
      } finally {
        this.saveLoading = false
      }
    },
    async handleDownloadFile(tableRow) {
      const $index = tableRow.$index
      this.$set(this.tableData[$index], 'downloadLoading', true)
      try {
        const fileUrl = tableRow.row.resultUrl
        if (!fileUrl) {
          this.$message.error('File URL not found')
          return
        }
        await downloadFile({
          url: fileUrl,
          fileName: tableRow.row.resultFileName,
        })
        this.$message.success('Download started')
      } catch (err) {
        console.error(err)
        this.$message.error('Download failed')
      } finally {
        this.$set(this.tableData[$index], 'downloadLoading', false)
      }
    },
    async handleDownloadOriginalFile(tableRow) {
      try {
        const fileUrl = tableRow.row.reportUrl
        if (!fileUrl) {
          this.$message.error('Original file URL not found')
          return
        }
        await downloadFile({ url: fileUrl, fileName: tableRow.row.reportName })
        this.$message.success('Download started')
      } catch (err) {
        console.error(err)
        this.$message.error('Download failed')
      }
    },
    handleSearchChange(params) {
      // 删除不需要的参数
      delete params.size

      // 添加客户相关信息
      if (this.vagueValue) {
        const selectedCustomer = this.customerList.find(
          customer => customer.id === this.vagueValue,
        )
        if (selectedCustomer) {
          params.companyId = selectedCustomer.id
          params.code = selectedCustomer.code
          params.name = selectedCustomer.name
        }
      }

      params.reportStatus = this.reportStatus
      // 新增 submittedBy 参数
      if (this.submittedBy) {
        params.submittedBy = this.submittedBy
      }
      params.current = 1
      this._getTableData(params)
    },
    async handleRemoteSearch(query) {
      if (query !== '') {
        this.customerLoading = true
        try {
          const data = await getCustomerByName(query)
          this.customerList = data.map(item => ({
            ...item,
            displayName: `${item.name} - ${this.customerType(
              item.customerType,
            )}`,
          }))
        } catch (error) {
          console.error('搜索客户失败:', error)
          this.customerList = []
        } finally {
          this.customerLoading = false
        }
      } else {
        this.customerList = []
      }
    },
    handleCustomerSelect() {
      // 选择客户时不立即触发搜索，等待用户点击搜索按钮
    },
    handleClearCustomer() {
      // 清空客户选择时，只清除客户列表，不立即搜索
      this.customerList = []
    },
    handleClickClearBtn() {
      // 清除所有搜索条件
      this.vagueValue = ''
      this.reportStatus = ''
      this.customerList = []
      this.submittedBy = ''
      this.submittedByOptions = []
    },
    async handleAddFormRemoteSearch(query) {
      if (query !== '') {
        this.addFormCustomerLoading = true
        try {
          const data = await getCustomerByName(query)
          this.addFormCustomerList = data.map(item => ({
            ...item,
            displayName: `${item.name} - ${this.customerType(
              item.customerType,
            )}`,
          }))
        } catch (error) {
          console.error('搜索客户失败:', error)
          this.addFormCustomerList = []
        } finally {
          this.addFormCustomerLoading = false
        }
      } else {
        this.addFormCustomerList = []
      }
    },
    handleAddFormClearCustomer() {
      this.addFormCustomerList = []
    },
    async handleSaveToFinancialReport(tableRow) {
      const result = await duplicateFinancialReport({
        reportType: tableRow.row.reportType,
        reportYear: tableRow.row.reportTime,
        companyId: tableRow.row.companyId,
      })

      if (result) {
        this.$confirm(
          'Duplicate files already exist in the system',
          'Warning',
          {
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            type: 'warning',
          },
        )
          .then(() => {
            // 用户点击继续，执行保存操作
            this.openSaveToReportDialog(tableRow)
          })
          .catch(() => {
            // 用户点击取消，不执行任何操作
            console.log('User cancelled the operation')
          })
      } else {
        this.openSaveToReportDialog(tableRow)
      }
    },
    openSaveToReportDialog(tableRow) {
      this.currentRowData = tableRow.row
      this.saveToReportForm = {
        periodEnding: '',
        accountType: '',
        auditorsOpinion: '',
      }
      this.saveToReportVisible = true
    },
    handleSaveToReportCancel() {
      this.saveToReportVisible = false
      this.currentRowData = null
    },
    async handleSaveToReportSubmit() {
      // 表单验证
      if (!this.saveToReportForm.periodEnding) {
        this.$message.error('Please select Period Ending')
        return
      }

      this.saveToReportLoading = true
      try {
        await saveToFinancialReport({
          id: this.currentRowData.id,
          periodEnding: this.saveToReportForm.periodEnding,
          accountType: this.saveToReportForm.accountType,
          auditorsOpinion: this.saveToReportForm.auditorsOpinion,
        })

        this.$message.success('Saved to Financial Report successfully')
        this.saveToReportVisible = false
        this.currentRowData = null
        // 重新加载表格数据
        this._getTableData()
      } catch (err) {
        console.error(err)
        this.$message.error('Save failed')
      } finally {
        this.saveToReportLoading = false
      }
    },
    beforeUpload(file) {
      // 检查文件类型
      const validTypes = [
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]
      if (!validTypes.includes(file.type)) {
        this.$message.error('Only PDF, Excel, and Word files are allowed!')
        return false
      }

      // 检查文件大小 (1024MB = 1GB)
      const isLt1G = file.size / 1024 / 1024 < 1024
      if (!isLt1G) {
        this.$message.error('File size cannot exceed 1GB!')
        return false
      }

      return true
    },
    async customUpload(option) {
      try {
        // 创建 FormData 对象
        const formData = new FormData()
        formData.append('file', option.file)

        // 调用 aiUploadFile 接口
        const response = await aiUploadFile(formData)

        // 上传成功后调用成功回调
        this.handleUploadSuccess(response, option.file, [
          ...this.fileList,
          option.file,
        ])
      } catch (error) {
        console.error('Upload error:', error)
        this.handleUploadError(error, option.file, this.fileList)
      }
    },
    handleUploadSuccess(response, file, fileList) {
      // 更新表单数据，response 直接就是返回的文件 url
      this.form.attachments = [
        {
          url: response,
          fileName: file.name,
        },
      ]
      this.fileList = fileList
      this.$message.success('File uploaded successfully!')
    },
    handleUploadError(err) {
      console.error('Upload error:', err)
      this.$message.error('File upload failed!')
    },
    handleRemove(file, fileList) {
      this.form.attachments = []
      this.fileList = fileList
    },
    handleCustomerIdClick(tableRow) {
      const companyId = tableRow.row.companyId
      if (companyId) {
        const url = `/customer-management/${companyId}/info/snapshot`
        this.$router.push(url)
      } else {
        this.$message.error('Company ID not found')
      }
    },
  },
  watch: {
    'form.currency': {
      handler(newVal) {
        if (newVal === 'USD') {
          // 如果是USD，清空汇率字段
          this.form.exchangeRate = ''
          return
        }
        // 如果不是USD且有交换日期，则请求汇率
        if (newVal && this.form.exchangeDate) {
          this._getCurrenyRate()
        }
      },
    },
    'form.exchangeDate': {
      handler(newVal) {
        // 如果是USD，不请求汇率
        if (this.form.currency === 'USD') {
          return
        }
        // 如果有货币且有交换日期，则请求汇率
        if (newVal && this.form.currency) {
          this._getCurrenyRate()
        }
      },
    },
  },
}
</script>
